import { Image } from '../../snippets';

export function PressSliderThumb({ alt, image, isActive, onClick }) {
  return (
    <div className="relative mx-auto flex w-full max-w-[8rem] justify-center pb-2">
      <button
        className="relative aspect-[3/2] w-full overflow-hidden"
        onClick={onClick}
        type="button"
      >
        <div className="absolute left-0 top-1/2 flex aspect-square w-full -translate-y-1/2 items-center justify-center overflow-hidden">
          {image?.src && (
            <Image
              alt={alt}
              className={`object-contain transition ${
                isActive ? 'opacity-100' : 'opacity-30'
              }`}
              width="128"
              height="128"
              src={image.src}
            />
          )}
        </div>
      </button>

      <div
        className={`absolute bottom-0 left-0 h-px w-full origin-center bg-current transition ${
          isActive ? 'scale-100' : 'scale-0'
        }`}
      />
    </div>
  );
}

PressSliderThumb.displayName = 'PressSliderThumb';
